import React, {useState, useContext} from 'react';
import firebase from 'firebase';

import { Button, Dropdown, Input, Modal } from 'semantic-ui-react';
import { GlobalContext } from '../contexts/GlobalContext';


const SetPositionCellModal = (props) => {

    const [state, setState] = useContext(GlobalContext);
    const [name, setName] = useState('');
    const [position, setPosition] = useState('');



    const setPositionCell = (selectedCells) => {

        console.log('Postion set');

        // loop through selection array
        // check if cell is in 'positionCell' array, 
        // check if it is marked as 'position'
        // mark it

        state['selectedCells'].map( (e) => {

            let addedEntry = e;
            addedEntry['position'] = position;

            //ensure cell doesn't already exist in array.
            if ( state['positionCells'].find( (f) => {
                return (f.column === e.column && f.row === e.row);
            }) === undefined ) {
                // add selected cell(s) to positionCells
                setState( (prevState) => { //set positionCells to selectionCells
                    return {...prevState, positionCells: [...prevState['positionCells'], addedEntry]}
                } );
            }
            else {
                // don't add because it already exists in the positionCells array
            }


            
        });
        props.onClose();
    }


    const updateName = (e) => {
        setName(e.target.value);
    }
    
    const updatePosition = (e, data) => {
        setPosition(data.value);
    }
    
    return (
        <div>

            <Modal dimmer='blurring' open={props.show}
                    role='dialog'
            >
            <Modal.Header>Set to Position Cell</Modal.Header>
            <Modal.Content>
                <Input placeholder='Name' onChange={updateName} />
                <Dropdown
                    fluid
                    search
                    selection
                    placeholder='Positions'
                    options={state['positions'] ? state['positions'].map( (q) => ({key: q.name, text: q.name, value: q.name} )) : []}
                    onChange={updatePosition}
                />
            </Modal.Content>
            <Modal.Actions>
                <Button basic onClick={props.onClose} >
                Cancel
                </Button>
                <Button color='blue' onClick={ setPositionCell } >
                Set Cell
                </Button>
            </Modal.Actions>
            </Modal>
        </div>
    );
};

export default SetPositionCellModal;